import FieldReferenceIdAndKeyDto from "../../../dtos/FieldReferenceIdAndKeyDto";
import PathMetaApiMappingCapabilitiesDto from "../../../dtos/pathmetaapimodule/PathMetaApiMappingCapabilitiesDto";
import TransformationCapabilitiesDto from "../../../dtos/transformationmodule/TransformationCapabilitiesDto";

class GetPathMetaApiCapabilitiesResult {
    SourceFields: FieldReferenceIdAndKeyDto[];
    MappingsCapabilities: PathMetaApiMappingCapabilitiesDto[];
    TransformationsCapabilities: TransformationCapabilitiesDto[]; 

    constructor(sourceFields: FieldReferenceIdAndKeyDto[], mappingsCapabilities: PathMetaApiMappingCapabilitiesDto[], transformationCapabilities: TransformationCapabilitiesDto[]) {
        this.SourceFields = sourceFields;
        this.MappingsCapabilities = mappingsCapabilities;
        this.TransformationsCapabilities = transformationCapabilities;
    }
}

export default GetPathMetaApiCapabilitiesResult;
